import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Layout from '../components/layout/Layout';
import ResultsHeader from '../components/results/ResultsHeader';
import ResultsSummary from '../components/results/ResultsSummary';
import ResultsVisualization from '../components/results/ResultsVisualization';
import CategoryBreakdown from '../components/results/CategoryBreakdown';
import NextSteps from '../components/results/NextSteps';
import { useTestStore } from '../store/testStore';
import { generateValidatedPDF } from '../utils/pdfGenerator';

const ResultsPage: React.FC = () => {
  const navigate = useNavigate();
  const { results, isTestCompleted, resetTest, startTest, userDetails } = useTestStore();
  
  useEffect(() => {
    console.log('ResultsPage mounted');
    console.log('isTestCompleted:', isTestCompleted);
    console.log('results:', results);
    
    // Redirect to home if test is not completed or no results
    if (!isTestCompleted || !results) {
      console.log('Test not completed or no results, redirecting to home');
      navigate('/');
      return;
    }
  }, [isTestCompleted, results, navigate]);
  
  // Show loading while checking state
  if (!results) {
    return (
      <Layout>
        <div className="container-custom py-8">
          <div className="flex items-center justify-center min-h-[400px]">
            <div className="text-center">
              <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600 mx-auto mb-4"></div>
              <p className="text-gray-600">Loading your results...</p>
            </div>
          </div>
        </div>
      </Layout>
    );
  }
  
  const handleRestartTest = () => {
    resetTest();
    startTest();
    navigate('/test');
  };
  
  const handleDownloadPDF = async () => {
    try {
      await generateValidatedPDF(results, userDetails);
    } catch (error) {
      console.error('Failed to generate PDF:', error);
      // You could add a toast notification here instead of alert
      alert('Failed to generate PDF report. Please try again.');
    }
  };
  
  return (
    <Layout>
      <div className="container-custom py-8">
        <ResultsHeader 
          results={results}
          onRestart={handleRestartTest}
          onDownloadPDF={handleDownloadPDF}
        />
        
        <ResultsSummary results={results} />
        
        <ResultsVisualization results={results} />
        
        <CategoryBreakdown results={results} />
        
        <NextSteps results={results} />
      </div>
    </Layout>
  );
};

export default ResultsPage;